import type { Observation } from "fhir/r4";
import type { FC } from "react";
import React, { useMemo } from "react";
import ObservationBundleBloc from "src/state/ObservationBundleBloc/ObservationBundleBloc";
import { useBlocNext } from "@blac/react";
import { ReferenceRangeBar as ReferenceRangeBarBase } from "@9amhealth/shared";

interface ReferenceRangeBarProps {
  observation: Observation;
}

const ReferenceRangeBar: FC<ReferenceRangeBarProps> = ({ observation }) => {
  const [, { getRangeContainingObservation, getObservationRangesData }] =
    useBlocNext(ObservationBundleBloc);

  const { observationValue, ranges, normalRangeMin, normalRangeMax } = useMemo(
    () => getObservationRangesData(observation),
    [observation]
  );

  const activeRangeId = useMemo(
    () => getRangeContainingObservation(observation)?.id,
    [observation]
  );

  if (!ranges?.length || typeof observationValue !== "number") {
    return null;
  }

  return (
    <ReferenceRangeBarBase
      observationValue={observationValue}
      ranges={ranges}
      normalRangeMin={normalRangeMin}
      normalRangeMax={normalRangeMax}
      activeRangeId={activeRangeId}
    />
  );
};

export default ReferenceRangeBar;
